import { Comment as CommentType } from "@/src/types/comments";
import { Collapse } from "@material-tailwind/react";
import { useState } from "react";
import ArticleCommentsTextInput from "../ArticleComments/TextInput";
import Image from "next/image";
export interface CommentProps {
  comment: CommentType;
  onReply: (id: number, content: string) => void;
}

const Comment = ({ comment, onReply }: CommentProps) => {
  const [expanded, setExpanded] = useState(false);

  const handleReplySubmit = async (text: string) => {
    onReply(comment.databaseId, text);
    return Promise.resolve(true);
  };

  return (
    <article className="p-6 pl-0 text-base bg-white rounded-lg dark:bg-gray-900">
      <footer className="flex justify-between items-center mb-2">
        <div className="flex items-center">
          <p className="inline-flex items-center mr-3 text-sm text-gray-900 dark:text-white font-bold">
            {comment.author.node.avatar && (
              <img
                className="mr-2 w-6 h-6 rounded-full"
                src={comment.author.node.avatar.url}
                alt={`${comment?.author?.node?.name}'s image`}
              />
            )}
            {comment?.author?.node?.name}
          </p>
          <p className="text-sm text-gray-600 dark:text-gray-400">
            <time dateTime="2022-02-08" title="February 8th, 2022">
              {comment?.date}
            </time>
          </p>
        </div>
      </footer>
      <div dangerouslySetInnerHTML={{ __html: comment?.content ?? {} }}></div>

      <div className="flex items-center mt-4 space-x-4">
        <button
          type="button"
          className="flex items-center text-sm text-gray-500 hover:underline dark:text-gray-400 font-medium"
          onClick={() => setExpanded(!expanded)}
        >
          <svg
            className="mr-1.5 w-3.5 h-3.5"
            aria-hidden="true"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 20 18"
          >
            <path
              stroke="currentColor"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M5 5h5M5 8h2m6-3h2m-5 3h6m2-7H2a1 1 0 0 0-1 1v9a1 1 0 0 0 1 1h3v5l5-5h8a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1Z"
            />
          </svg>
          Reply
        </button>
      </div>
      <Collapse open={expanded}>
        <div className="mt-2">
          <ArticleCommentsTextInput onSubmit={handleReplySubmit} />
        </div>
      </Collapse>
    </article>
  );
};

export default Comment;
